import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { loadingAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai';
import { Fragment } from 'react';

function GlobalLoader() {
    const isLoading = useAtomValue(loadingAtom);
    if (isLoading) {
        return (
            <Background>
                <Loading/>
            </Background>
        );
    }
    return <Fragment/>;
}

const Background = styled.div`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    height: 100vh;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 100;
`;

export default GlobalLoader;
